export enum PermissionRoleName {
  Administer = 'administer',
  Explore = 'explore',
  Publish = 'publish',
  View = 'view',

  // Special roles names:
  Denied = 'denied', // when all capabilities are denied
  None = 'none', // when all capabilities are unspecified
  Custom = 'custom',
}
